import { render, staticRenderFns } from "./YeniFiyatlandirmaBilgi.vue?vue&type=template&id=dba4e4e4&scoped=true"
import script from "./YeniFiyatlandirmaBilgi.vue?vue&type=script&lang=js"
export * from "./YeniFiyatlandirmaBilgi.vue?vue&type=script&lang=js"
import style0 from "./YeniFiyatlandirmaBilgi.vue?vue&type=style&index=0&id=dba4e4e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dba4e4e4",
  null
  
)

export default component.exports